import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


import props from "@/props/whiteSpace";

//import components
import { defineComponent } from "vue";
const __default__ = defineComponent({
  name: "WhiteSpace",
  inheritAttrs: true,
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: props,
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle({ height: `${Math.abs(Math.round(_ctx.height))}px` })
  }, null, 4))
}
}

})